import { render, staticRenderFns } from "./FaucetSlider.vue?vue&type=template&id=06cb7c6d&"
import script from "./FaucetSlider.vue?vue&type=script&lang=js&"
export * from "./FaucetSlider.vue?vue&type=script&lang=js&"
import style0 from "./FaucetSlider.vue?vue&type=style&index=0&id=06cb7c6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports